@if (notification.object && notificationDisplay && notificationDisplay.label) {
  <div
    (click)="onNotificationClick($event, notification)"
    #handelNotification
    class="bs-callout notification-container d-flex align-items-center"
    [ngClass]="{ notificationUnseen: !notification.seen }"
    [style.opacity]="NotificationViewType.Toast ? viewOpacity : 1"
    [style.position]="'relative'">
    @if (showSectionBorder) {
      <div [class]="`section-border  ${notification.customBorderClass ? notification.customBorderClass : ''}`"> </div>
    }

    <!-- starting  -->
    <div class="flex-row d-flex w-100">
      <div class="notification-body flex-column d-flex gap-2">
        <div class="flex-row d-flex align-items-center gap-2">
          <mtm-user-profile-picture
            [forceLoadProfile]="true"
            [username]="notification.object.notifiedByUsername"
            [avatarUrl]="notification.object.notifiedByAvatarUrl"
            [height]="23"
            [width]="23">
          </mtm-user-profile-picture>
          <span class="notificationUsername">{{ notification.object.notifiedBy }}</span>
          <!-- @if(notification.object.notifiedBy && mode != NotificationViewType.RecentActivity && mode !=
				NotificationViewType.Toast){
				<span class="mx-2 notificationBar">|</span>
				}
				@if(mode != NotificationViewType.RecentActivity && mode !=
				NotificationViewType.Toast){
				<span class="notificationSectionNameAndJobTitle">
					{{notification.object.jobTitle}}
				</span>
				} -->
        </div>

        @if (notification.date) {
          <div class="d-flex flex-row align-items-center gap-2">
            @if (mode === NotificationViewType.List) {
              <span class="notificationDateAndTime">{{ notification.date | mtmDateTime }}</span>
            }
            @if (mode === NotificationViewType.RecentActivity || mode === NotificationViewType.Toast) {
              <span class="notificationDateAndTime">{{ notification.date | mtmDateTime }}</span>
            }
          </div>
        }

        <div class="d-flex flex-row align-items-center flex-wrap">
          @if (isExtTaskNotification) {
            @for (segment of pathSegments; track segment; let last = $last) {
              <span class="notificationSectionNameAndJobTitle">{{ segment }}</span>
              @if (!last) {
                <span class="mx-2 notificationBar">|</span>
              }
            }
          } @else {
            @if (notification.object.sectionName) {
              <span class="notificationSectionNameAndJobTitle"> {{ notification.object.sectionName }}</span>
            }
            @if (notification.object.sectionName && notification.object.projectName) {
              <span class="mx-2 notificationBar">|</span>
            }
            @if (notification.object.projectName) {
              <span class="notificationSectionNameAndJobTitle">
                {{ notification.object.projectName }}
              </span>
            }
          }
        </div>

        <div class="w-100 notificationDescription flex-column d-flex gap-2">
          <div class="label text-wrap" [class.ext-task-action]="isExtTaskNotification">
            {{ 600 > screenWidth ? `${notificationDisplay.label.slice(0, 30)}...` : notificationDisplay.label }}
          </div>

          <!-- @if (notification.object.projectName && projectMoved === false ) {
				@if (nameVisible === false) {
				<div class="project-name" (mouseenter)="mouseEnter()">
					{{600 > screenWidth?
					((getProjectName(notification)).slice(0,30))+"...": getProjectName(notification)}}
				</div>
				} @else {
				<div class="project-name" (mouseleave)="mouseLeave()">
					{{600 > screenWidth?
					((notification.object.projectName).slice(0,30))+"...": notification.object.projectName}}

				</div>
				}
				} -->

          @if (notification.object.workspaceName) {
            @if (nameVisible === false) {
              <div class="project-name" (mouseenter)="mouseEnter()">
                {{
                  notification.object.workspaceName.length > 0
                    ? `${notification.object.workspaceName.slice(0, 30)}...`
                    : notification.object.workspaceName
                }}
              </div>
            } @else {
              <div class="project-name" (mouseleave)="mouseLeave()">
                {{
                  600 > screenWidth
                    ? `${notification.object.workspaceName.slice(0, 30)}...`
                    : notification.object.workspaceName
                }}
              </div>
            }
          }

          @if (notificationDisplay?.action?.showCompany) {
            <div class="project-name">
              {{ 'notificationCOMPANY_NAME' | translate: { COMPANY_NAME: notificationDisplay.action.companyName } }}
            </div>
          }
        </div>
      </div>

      <div class="d-flex align-items-center">
        <i class="fa fa-chevron-right" aria-hidden="true" style="color: black; position: relative"></i>
      </div>
    </div>

    <!-- OAFIXMe see with caroline if we keep this -->
    <span class="close-button" *ngIf="showCloseButton" (click)="$event.stopPropagation(); closeNotification()"
      ><i class="fa fa-times" aria-hidden="true"></i
    ></span>
  </div>
}
